import Vue from 'vue';
import App from './App.vue';
import moment from 'moment';

require('@/other/AirBnbDatepickerDefaults.js');
require('@/other/ApexDefaults.js');
moment.locale('ru');

//Vue.config.performance = true
Vue.config.productionTip = false;

var vue = new Vue({
  render: (h) => h(App),
}).$mount('#app');

